import { useContext } from "react";
import { useTechnologies } from "hooks";
import QueryContext from "state/query";
import DropdownSelect from "./DropdownSelect";
import { faGear } from "@fortawesome/pro-light-svg-icons";
import { faGear as solidGear } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import s from "./filter.module.css";

const SelectTechnologies = () => {
  const { technologies } = useTechnologies();
  const { technologies: selectedTechnologies, setTechnologies } =
    useContext(QueryContext);

  return (
    <div className="relative h-full grow text-center group">
      <DropdownSelect
        title="Technologies"
        value={selectedTechnologies}
        options={technologies}
        onChange={setTechnologies}
        icon={<FontAwesomeIcon icon={faGear} className={`${s.icon} group-hover:hidden`} />}
        iconHover={<FontAwesomeIcon icon={solidGear} className={`${s.icon} hidden group-hover:inline-block`} />}
      />
    </div>
  );
};

export default SelectTechnologies;
